export const environment = {
  production: false,
  protocolsApiUrl: 'https://api.staging.getlilo.io/protocols',
  authorizationApiUrl: 'https://api.staging.getlilo.io/login',
};
